import { targetAppKey } from "../rules/ruleDerivation";

/** Raw insight/scoring key: bundle id when present, otherwise display name (no `app:` prefix). */
export function insightRawAppKey(app: { appIdentifier?: string; displayName: string }): string {
  return app.appIdentifier?.trim() || app.displayName.trim();
}

/** Strip the Habits/Targets `app:` namespace prefix, if present. */
export function rawKeyFromNamespaced(key: string): string {
  return key.startsWith("app:") ? key.slice("app:".length) : key;
}

/** Namespaced filter key used in habitPrefs and habitAppSearch (`app:<raw>`). */
export function toNamespacedAppKey(app: { appIdentifier?: string; displayName: string }): string {
  return targetAppKey(app);
}

/** Build a set of raw keys from persisted excluded prefs (always namespaced `app:…`). */
export function buildExcludedRawKeySet(excludedAppKeys: string[] | undefined): Set<string> {
  const set = new Set<string>();
  for (const key of excludedAppKeys ?? []) {
    const raw = rawKeyFromNamespaced(key).trim();
    if (raw) set.add(raw);
  }
  return set;
}

export function isRawAppKeyExcluded(rawKey: string, excluded: Set<string>): boolean {
  return excluded.has(rawKey.trim());
}
